export const Mainlaystyle = (theme) => ({
    rootBox: {
        display: "grid",
        gridTemplateColumns: "1.1fr 5fr",
        height: "100vh",
        width: '100vw',
        overflowX: "hidden",
    },
    componentDiv: {
        flexGrow: 1, display: "flex", flexDirection: "column"
    },

    outletDiv: {
        height: "90vh", overflowY: "auto", background: theme.palette.primary.backgroundMain,
        p: 3,
    },

    HeaderDiv: {
        height: "10vh", 
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        display: "flex", alignItems: "center", 
        justifyContent: "flex-end",
        px:4
    }
})

export const sidenavStyle = (theme) => ({
    active: {
        borderRight: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: "#ffa2001a",
        color: theme.palette.primary.main,
        fontSize: 14,
    },

    inactive: {
        fontWeight: "bold",
        mb: 0.5,
        color: theme.palette.text.primary,
        bgcolor: "transparent",
        "&:hover": {
            bgcolor: "rgba(224,221,220,0.3)",
        },
    },

    drawerDiv: {
        flex: 1,
        "& .MuiDrawer-paper": {
            position: "relative",
            width: "100%",
            boxSizing: "border-box",
            borderRight: `1px solid ${theme.palette.border.thin}`,
        },
    },

    sidenavHeader: {
        p: 2, borderBottom: "1px solid #ddd", display: "flex", alignItems: "center", gap: 1, height: '10vh'
    },

    sidenavBody: {
        height: "90vh",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto"
        }
    },

    versionDiv: {
        m: 1,
        mx:2,
        p: 1,
        border: `1px solid ${theme.palette.border.thin}`,
        borderRadius: 1,
        "&:hover": {
            bgcolor: "rgba(224,221,220,0.2)",
            borderColor: `${theme.palette.border.thin}`,
        },
    },


    logo: {
        width: "45px",
        height: "45px",
        objectFit: "contain",
    },
})

export const HeaderStyles = (theme) => ({
    appBar: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: "none",
        p: 0,
    },
    title: {
        fontSize: "1rem",
        fontWeight: 600,
        color: theme.palette.text.primary,

    },
    subtitle: {
        color: theme.palette.text.secondary,
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 0,
    },
    iconButton: {
        position: "relative",
        width: 40,
        height: 40,
    },
    bellIcon: {
        width: 20,
        height: 20,
        color: theme.palette.text.primary,
    },
    badge: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: "0.75rem",
        width: 20,
        height: 20,
        minWidth: 20,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    version: {
        mb: 2,
        p: 1,
        borderBottom: `1px solid ${theme.palette.border.thin}`,
        borderRadius: 1,
        bgcolor: "#fffdf8",
    },

})